import styled from "styled-components";
import { AllieItem } from '../../../components/Item/Item';

export const PerformanceBarsStyled = styled(AllieItem)`
  background-color: var(--allie-color-neutral-10);
  border-radius: 0 12px 12px 0;
  ::part(native) {
    padding: 0;
  };
  --inner-padding-end: 5px;
`;

export const PeformanceSummaryStyled: any = styled("div")`
  padding: 9px;
  text-align: center;
  border-radius: 4px 0 0 4px;
  width: 128px;
  margin-right: 10px;
  background-color: var(--allie-color-${(props: any) => props.backgroundColor});
`;

export const PerformanceBarsContainerStyled: any = styled("div")`
  width: ${(props: any) => props.width || "-webkit-fill-available"};
  align-self: center;
`;

export const PerformanceBarStyled = styled("div")`
  margin: 5px;
`;
